import { render } from "./AppVersionUpdate.vue?vue&type=template&id=629de4da&lang=true"
import script from "./AppVersionUpdate.vue?vue&type=script&lang=js"
export * from "./AppVersionUpdate.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__